// utils
// import { suggestedNetwork } from '../../components/carousel/network/NetworkCarousel.mocks';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useState } from 'react';
import WhatsAppComponent from '../../components/fixed/whatsapp/WhatsappComponent';
import PopUpComponent from '../../components/popUp/PopUpComponent';
import { formatSelects, isColorLight } from '../../utils/FunctionsGlobals';
import { buildCanonical } from '../../utils/url';
// import NetworkPieces from '../../components/pieces/network/NetworkPieces';
import { motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import { useAuth } from '../../components/context/Info';
import WelcomePiecesCompany from '../../components/pieces/welcomeCompany/WelcomePiecesCompany';
import { politic_default } from '../../configs/constants';
import LegalText from '../../components/shared/legal-text/LegalText';
import { getDefaultServerSideProps } from '../../lib/server/site-props';
import { ehModeloCampo, varsCampoPagina } from '../../components/pieces/campo/campoInternas';
import cpInterna from '../../components/pieces/campo/CampoInterna.module.css';
import styles from './Politic.module.css';

const AboutPieces = dynamic(() => import('../../components/pieces/about/AboutPieces'), { ssr: false });
const AboutPieces1 = dynamic(() => import('../../components/pieces/about1/AboutPieces1'), { ssr: false });
import { NEW_RODAPE } from '../../components/registry/home';
const AboutPieces2 = dynamic(() => import('../../components/pieces/about1/AboutPieces2'), { ssr: false });
const MegaFooter = dynamic(() => import('../../components/pieces/mega-footer/MegaFooter'), { ssr: false });
const EditorialFooter = dynamic(() => import('../../components/pieces/editorial-footer/EditorialFooter'), { ssr: false });

export const getServerSideProps = getDefaultServerSideProps;

const Politic = () => {
    // useState
    const router = useRouter();
    const {
        allDataHome,
        isMobile1,
        init_props,
        favorito
    } = useAuth();
    // useState
    const allCity = allDataHome?.cidades;
    const allCities = allCity ? formatSelects(allCity) : [];
    const site = allDataHome?.site;
    const [activeDrawer, setActiveDrawer] = useState<any>(null);
    const bannerListagem = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "listagem");
    const urlBannerListagem = bannerListagem ? bannerListagem.length > 0 ? bannerListagem[0] : null : null;
    const routes = ['home', 'política'];
    const politica = site?.politica_privacidade || ''
    // Modelo #14 "Campo" (topo 18): a página na régua do modelo — papel, Inter, h1 40/800 na faixa de papel e o texto
    // em coluna de leitura de 720px (regras .textoCp do módulo). Fora do topo 18: o DOM e o estilo de sempre.
    const campo = ehModeloCampo(site);
    const cor_texto = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13;
    const codsite2 = init_props?.codsite;
    const origin = init_props?.prodOrigin;
    const canonicalUrl = buildCanonical(site?.site || init_props?.prodOrigin, router.asPath || '/politica');

     const renderRodape = () => {
        // REGISTRY: variante nova de rodapé ANTES do switch legado — o lookup devolve
        // undefined para os modelos 1-5, então o diff nos ~300 sites é nulo.
        const RodapeNovo = NEW_RODAPE[Number(site?.rodape)];
        if (RodapeNovo) {
            return (
                <RodapeNovo
                    site={site}
                    allCities={allCities}
                    allCitiesTipes={allDataHome?.tipos}
                    codsite={codsite2}
                    origin={origin}
                    isMobile={isMobile1}
                    allRodape={allDataHome?.rodape}
                    favorito={favorito}
                />
            );
        }

        switch (site?.rodape) {
            case 1:
                return (
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
                    </motion.div>
                );
            case 2:
                return (
                    <AboutPieces allRodape={allDataHome?.rodape} site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1}/>
                );
            case 3:
                return (
                    <AboutPieces2 site={site} allRodape={allDataHome?.rodape}/>
                );
            case 4:
                return (
                    <MegaFooter
                        site={site}
                        allCities={allCities}
                        codsite={codsite2}
                        origin={origin}
                        isMobile={isMobile1}
                        favorito={favorito}
                        allRodape={allDataHome?.rodape}
                        fallback={<AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>}
                    />
                );
            case 5:
                return (
                    <EditorialFooter
                        site={site}
                        allCities={allCities}
                        codsite={codsite2}
                        origin={origin}
                        isMobile={isMobile1}
                        favorito={favorito}
                        allRodape={allDataHome?.rodape}
                        fallback={<AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>}
                    />
                );
            default:
            return (
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
                </motion.div>
            );
        }
    }

    return (
        <div className={campo ? `${styles.container} ${cpInterna.interna}` : styles.container} style={campo ? (varsCampoPagina(site) || undefined) : {background: site?.cor5}} data-modelo={campo ? 'campo' : undefined}>
            <Head>
                <title>Política</title>
                <meta name="robots" content="index, follow" />
                <meta property="og:url" content={canonicalUrl} />
                <link rel="canonical" href={canonicalUrl} key="canonical" />
            </Head>
            <WhatsAppComponent site={site} />
            <PopUpComponent />
            <WelcomePiecesCompany
                site={site}
                routes={routes}
                setActiveDrawer={setActiveDrawer}
                activeDrawer={activeDrawer}
                favorito={[]}
                bannerListagem={urlBannerListagem}
                props={allDataHome}
            />
            {campo ? (
                <header className={cpInterna.faixa}>
                    <p className={cpInterna.sobretitulo}>{site?.Dados?.empresa || site?.titulo}</p>
                    <h1 className={cpInterna.tituloPagina}>Política de privacidade</h1>
                </header>
            ) : (
                <label className={styles.subtitle} style={{color: cor_texto}}>POLÍTICA DE PRIVACIDADE</label>
            )}
            <p className={campo ? `${styles.adjust_terms} ${styles.textoCp}` : styles.adjust_terms} style={campo ? undefined : {color: cor_texto}}>
                <LegalText texto={politica || politic_default(site)} site={site} />
            </p>
            { renderRodape() }

        </div>
    );
};

export default Politic;
